import { googleLogout } from "@react-oauth/google";
import SignOutIcon from "@atlaskit/icon/glyph/sign-out";

import { ListItemIcon } from "../../UI/ListItemIcon";
import { ListItemText } from "../../UI/ListItemText";
import { useLogout } from "../../hooks/useLogout";
import { StyledListItemButton } from "./styles";
import {getAppConfig } from "../../AppConfig";
import { GOOGLE_CLIENT_ID } from "../../constants/general";

export const LogoutListItem = () => {
  const logout = useLogout();
  const appConfig = getAppConfig();

  const handleGoogleLogout = () => {
    googleLogout();
    logout();
  };

  return (
    <>
      {appConfig.provider === "Google" && GOOGLE_CLIENT_ID && (
        <StyledListItemButton onClick={handleGoogleLogout}>
          <ListItemIcon>
            <SignOutIcon label="Logout" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </StyledListItemButton>
      )}
      {appConfig.provider !== "Google" && (
        <StyledListItemButton onClick={logout}>
          <ListItemIcon>
            <SignOutIcon label="Logout" />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </StyledListItemButton>
      )}
    </>
  );
};
